module.exports = __webpack_public_path__ + "img/senalando-izqsv.png.ea79c4f0.webp";